import { replaceTokensInUrl } from '@app/utils';
import { getHttpInstance } from './defaultHttpService';
import endpoints from '@app/constants/endpoints';

export const getB2CToken = async storeId => {
  const http = getHttpInstance();
  const getB2CUrl = replaceTokensInUrl(endpoints.B2C_TOKEN, storeId);
  let accessToken = null;
  try {
    const { data } = await http.get(getB2CUrl, { withCredentials: true });
    if (data?.accessToken) {
      accessToken = data.accessToken;
    }
  } catch (error) {
    console.log('Get B2C token failed', error);
  }
  return accessToken;
};
